<div class="notice-banner-container"
     *ngIf="bannerVisible && data"
     role="alert"
     aria-live="polite"
     aria-atomic="true"
     [ngClass]="'alert-' + data.type">
  <div class="mainDiv alert alert-dismissible fade show" role="status">
    <div class="banner-content">
      <strong>{{ data.message }}</strong>
    </div>
    <button type="button"
            class="close"
            (click)="dismissBanner()"
            [attr.aria-label]="'Close ' + data.type + ' alert'"
            title="Close alert"
            [disabled]="false">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
